export default __webpack_public_path__ + "static/6600-e0b656827b563670068cad6f5ee5d0c9.jpg";